module.exports = __webpack_public_path__ + "static/media/RAL_2026_PDF.3ee001cf.pdf";